// Components
import { SearchResultProps } from 'semantic-ui-react';
import {
  U21Chip,
  U21ChipColor,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';

// Constants
import { ACTIVE_STATUSES, INACTIVE_STATUSES } from 'app/shared/constants';

// Styles
import styled from 'styled-components';

const TopSearchBarResult = ({
  title,
  description = '',
  icon,
  label,
}: SearchResultProps) => {
  let labelColor: U21ChipColor = 'default';
  if (label && ACTIVE_STATUSES.includes(label)) {
    labelColor = 'success';
  }
  if (label && INACTIVE_STATUSES.includes(label)) {
    labelColor = 'error';
  }

  return (
    <Container horizontal useFlexGap>
      <Content>
        <StyledU21Typography variant="body2">{title}</StyledU21Typography>
        <StyledU21Typography
          color="text.secondary"
          variant="caption"
          htmlString={description}
        />
      </Content>
      <U21Spacer horizontal useFlexGap>
        {label && (
          <U21Chip color={labelColor}>
            {USER_FRIENDLY_LABEL[label] ?? label}
          </U21Chip>
        )}
        {icon}
      </U21Spacer>
    </Container>
  );
};

const USER_FRIENDLY_LABEL: Record<
  (typeof ACTIVE_STATUSES)[number] | (typeof INACTIVE_STATUSES)[number],
  string
> = {
  ACTIVE: 'Active',
  OPEN: 'Open',
  CLOSED: 'Closed',
  INACTIVE: 'Inactive',
  ARCHIVED: 'Archived',
  EXPIRED: 'Expired',
};

const Container = styled(U21Spacer)`
  width: 100%;
  justify-content: space-between;
`;

const Content = styled.div`
  min-width: 300px;
`;

const StyledU21Typography = styled(U21Typography)`
  white-space: pre-wrap;
`;

export default TopSearchBarResult;
